import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, OnInit, inject } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { HeaderComponent } from '../../shared/header/header';
import { AppProgressComponent } from '../../shared/progress/progress';
import { filter, map, Subscription, Observable } from 'rxjs';
import { RequestTitleService } from '../../../services/shared/requset-title.service';
import { HomeHeaderComponent } from '../home/home-header/home-header/home-header.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'mi-request',
  imports: [
    RouterOutlet,
    HeaderComponent,
    CommonModule,
    AppProgressComponent,
    HomeHeaderComponent,
  ],
  templateUrl: './request.html',
  styleUrl: './request.scss',
  encapsulation: ViewEncapsulation.None,
})
export class RequestComponent {

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private requestTitleService = inject(RequestTitleService);

  isNeedProgress: boolean = false;
  isNeedMainHeader: boolean = false;
  requestTitle = toSignal(this.requestTitleService.getFormatRequestTitleText(), { initialValue: '' });

  constructor() {
    this.subscribeRoute();
  }

  subscribeRoute() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        map((route) => route.snapshot.data),
      )
      .subscribe((data) => {
        this.isNeedProgress = data['stepCondition'];
        this.isNeedMainHeader = data['isVisibleMainHeader'];
      });
  }

  isHomePage(): boolean {
    return this.router.url === '/home';
  }
}
